import {
  isMindmapNode,
  CaptureUpdateAction,
} from "@excalidraw/element";

import { isBindableElement } from "@excalidraw/element/typeChecks";

import { getSelectedElements } from "../scene";

import { register } from "./register";

export const actionConvertToMindmapNode = register({
  name: "convertToMindmapNode",
  label: "labels.convertToMindmapNode",
  viewMode: false,
  trackEvent: {
    category: "element",
  },
  predicate: (elements, appState, _, app) => {
    if (!appState.mindMapModeEnabled) {
      return false;
    }
    const selected = getSelectedElements(
      app.scene.getNonDeletedElementsMap(),
      appState,
    );
    return (
      selected.length > 0 &&
      selected.some((el) => isBindableElement(el) && !isMindmapNode(el))
    );
  },
  perform(elements, appState, _, app) {
    const selected = getSelectedElements(
      app.scene.getNonDeletedElementsMap(),
      appState,
    );

    let changed = false;
    for (const el of selected) {
      if (isBindableElement(el) && !isMindmapNode(el)) {
        app.scene.mutateElement(el, {
          customData: { ...el.customData, isMindmapNode: true },
          roundness: { type: 3 },
        });
        changed = true;
      }
    }

    return {
      captureUpdate: changed
        ? CaptureUpdateAction.IMMEDIATELY
        : CaptureUpdateAction.NEVER,
    };
  },
});
